import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Card, CardContent, CircularProgress, Grid, Typography } from '@material-ui/core';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import PostAddIcon from '@material-ui/icons/PostAdd';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import CardActionArea from '@material-ui/core/CardActionArea';


const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 20,
    minHeight: 120,
    maxHeight: 120
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    height: 56,
    width: 56,
    zIndex: 1,
    marginRight: -50
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center'
  },

  iconDiferencaPositivo: {
    color: theme.palette.success.dark
  },
  iconDiferencaNegativo: {
    color: theme.palette.error.dark,
  },
  valorDiferencaPositivo: {
    color: theme.palette.success.dark,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  valorDiferencaNegativo: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  cardContent: {
    zIndex: 1,
    marginTop: -90,
    marginRight: 25,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  gridProgress: {
    display: 'flex',
    justifyContent: 'center'
  }

}));

const CardAnaliseEstatistica = props => {
  const { className, abrirAnalise, valorPrincipal, ...rest } = props;

  const classes = useStyles();
  const [mostrarProgress, setMostrarProgress] = useState(false);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);


  return (
    <Grid
      container
      style={{
        display:'flex',
        justifyContent: 'center',
        verticalAlign: 'middle'
      }}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <Card
          {...rest}
          className={clsx(classes.root, className)}
          elevation={3}
        >
          <CardActionArea
            onClick={e => abrirAnalise()}
          >
            <CardContent

            >
              {
                mostrarProgress &&
                <Grid
                  container
                  md={12}
                  xs={12}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                    className={clsx({
                      [classes.gridProgress]: true
                    })}
                  >
                    <CircularProgress/>
                  </Grid>
                </Grid>
              }
              {
                !mostrarProgress && !mostrarAlertaErro &&
                <Grid
                  container
                >
                  <Grid
                    item
                    md={12}
                    xs={12}

                  >
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                      variant="body2"
                    >
                      ANÁLISE ESTATÍSTICA
                    </Typography>

                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{
                      marginBottom: 10
                    }}
                  >
                    <Typography
                      variant="h4"
                    >
                      {`${valorPrincipal} gráficos`}
                    </Typography>
                  </Grid>
                  <TrendingUpIcon
                    fontSize={'small'}
                    className={clsx({
                      [classes.iconDiferencaPositivo]: true,
                    })}
                  />
                  <Typography
                    className={clsx({
                      [classes.valorDiferencaPositivo]: true,
                    })}
                    variant="body2"
                  >
                    Gráficos e estatísticas
                  </Typography>

                </Grid>
              }

            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
        className={clsx({
          [classes.cardContent]: true
        })}
        onClick={e => abrirAnalise()}
      >
        <Avatar className={classes.avatar}>
          <EqualizerIcon className={classes.icon} />
        </Avatar>
      </Grid>
    </Grid>
  );
};

CardAnaliseEstatistica.propTypes = {
  className: PropTypes.string
};

export default CardAnaliseEstatistica;
